import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import dayjs from "dayjs";

import { TRANSLATIONS_EN, TRANSLATIONS_MM } from ".";

declare module "i18next" {
  // add data type for return null case
  interface CustomTypeOptions {
    returnNull: false;
  }
}
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    returnNull: false,
    interpolation: {
      format: function (value, format) {
        if (value instanceof Date) return dayjs(value).format(format);
        return value;
      },
    },
    resources: {
      en: {
        translation: TRANSLATIONS_EN,
      },
      mm: {
        translation: TRANSLATIONS_MM,
      },
    },
  });
